import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Quote(props) {
  const { height, width, iconColor } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Carousel/Testimony/XL" transform="translate(-705.000000, -108.000000)" fill={iconColor}>
          <g id="CarouselUI" transform="translate(81.000000, 108.000000)">
            <g id="Icons/UI/Carousel/Quote/White" transform="translate(624.000000, 0.000000)">
              <path d="M19.1016,12.2461 L19.1016,0.0001 L30.4106,0.0001 L30.4106,9.6681 C30.4106,14.9031 29.8046,18.6721 28.5936,20.9761 C26.9136,24.1411 24.2966,26.5241 20.7426,28.1251 L18.1646,23.9651 C20.2736,23.1061 21.8456,21.7481 22.8806,19.8921 C23.9156,18.0381 24.4926,15.4891 24.6096,12.2461 L19.1016,12.2461 Z M0.9376,12.2461 L0.9376,0.0001 L12.2466,0.0001 L12.2466,9.6681 C12.2466,14.9031 11.6406,18.6721 10.4296,20.9761 C8.7496,24.1411 6.1326,26.5241 2.5786,28.1251 L-0.0004,23.9651 C2.1096,23.1061 3.6816,21.7481 4.7166,19.8921 C5.7516,18.0381 6.3286,15.4891 6.4456,12.2461 L0.9376,12.2461 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

Quote.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Quote.defaultProps = {
  width: 31,
  height: 29,
  iconColor: colors.colorWhite
};

export default Quote;
